import { ChangeDetectorRef, Component } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';

import { merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { emailValidator } from '@recruitee/common';
import { InfoboxComponent } from '@recruitee/components/infobox';
import { TranslatePipe } from '@recruitee/i18n';
import type { DialogComponentI } from '@recruitee/user-interface';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  DialogRef,
  FormFieldComponent,
  InputComponent,
  LabelComponent,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-candidate-add-email-dialog',
  templateUrl: './candidate-add-email-dialog.component.html',
  styleUrls: ['./candidate-add-email-dialog.component.less'],
  imports: [
    DialogHeaderComponent,
    DialogBodyComponent,
    FormFieldComponent,
    LabelComponent,
    InputComponent,
    ReactiveFormsModule,
    DialogFooterComponent,
    ButtonComponent,
    TranslatePipe,
    InfoboxComponent,
  ],
})
export class CandidateAddEmailDialogComponent
  implements DialogComponentI<null, { email: string } | null>
{
  public emailControl = new FormControl('', [Validators.required, emailValidator]);

  private ngOnDestroy$ = new Subject<void>();

  constructor(
    private cdRef: ChangeDetectorRef,
    private dialogRef: DialogRef,
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setDialogData(data: null, triggerUpdate: boolean): void {}

  public ngOnInit(): void {
    merge(this.emailControl.valueChanges, this.emailControl.statusChanges)
      .pipe(takeUntil(this.ngOnDestroy$.asObservable()))
      .subscribe(() => this.cdRef.detectChanges());
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public cancel() {
    this.dialogRef.close(null);
  }

  public save() {
    this.dialogRef.close({
      email: this.emailControl.value,
    });
  }
}
